import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"

import "./CommonTable.vue?vue&type=style&index=0&id=5e2e86fe&lang=scss"

const __exports__ = script;

export default __exports__